import React, { useState, useEffect, useCallback, useRef } from 'react'

/* ─── Inline SVG Icons ─────────────────────────────────────────────────── */
const XIcon = () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
const CheckIcon = ({ className = 'w-5 h-5' }: { className?: string }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
const WarnIcon = () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/></svg>
const Spinner = () => <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
const PlusIcon = () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15"/></svg>
const TrashIcon = () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/></svg>
const PlayIcon = () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"/></svg>
const StopIcon = () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z"/></svg>
const SendIcon = () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"/></svg>
const RefreshIcon = () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182"/></svg>
const PhoneIcon = () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"/></svg>
const QRIcon = () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"/><path strokeLinecap="round" strokeLinejoin="round" d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"/></svg>

/* ─── Types ──────────────────────────────────────────────────────────────── */
interface WASession { id: string; name: string; status: string; phone?: string | null; pushName?: string | null; connectedAt?: string | null; lastActive?: string | null; createdAt?: string }
interface Props { open: boolean; onClose: () => void }
type Tab = 'overview' | 'sessions' | 'connection' | 'tester'

/* Status badge colours */
const STATUS_COLORS: Record<string, string> = {
  READY: 'bg-success/15 text-success',
  CONNECTED: 'bg-success/15 text-success',
  QR_READY: 'bg-warning/15 text-warning',
  CREATED: 'bg-info/15 text-info',
  INITIALIZING: 'bg-info/15 text-info',
  AUTHENTICATING: 'bg-warning/15 text-warning',
  DISCONNECTED: 'bg-txt-tertiary/15 text-txt-tertiary',
  FAILED: 'bg-error/15 text-error',
}

const STATUS_DESCRIPTIONS: Record<string, string> = {
  READY: 'WhatsApp is connected and working',
  QR_READY: 'Waiting for QR code scan',
  INITIALIZING: 'Starting WhatsApp session...',
  AUTHENTICATING: 'Authenticating with WhatsApp...',
  DISCONNECTED: 'Session is disconnected',
  FAILED: 'Session failed — needs reconnection',
  CREATED: 'Session created — needs to be started',
}

/* ─── Component ──────────────────────────────────────────────────────────── */
export const WhatsAppModal: React.FC<Props> = ({ open, onClose }) => {
  const [tab, setTab] = useState<Tab>('overview')

  // Connection status
  const [configured, setConfigured] = useState(false)
  const [connected, setConnected] = useState(false)
  const [activeSession, setActiveSession] = useState<WASession | null>(null)

  // Connection settings
  const [baseUrl, setBaseUrl] = useState('http://localhost:2785/api')
  const [apiKey, setApiKey] = useState('')
  const [testing, setTesting] = useState(false)
  const [connecting, setConnecting] = useState(false)
  const [statusMsg, setStatusMsg] = useState<{ type: 'success' | 'error' | 'info'; text: string } | null>(null)

  // Sessions
  const [sessions, setSessions] = useState<WASession[]>([])
  const [loadingSessions, setLoadingSessions] = useState(false)
  const [newSessName, setNewSessName] = useState('')
  const [creatingSess, setCreatingSess] = useState(false)

  // QR Code
  const [qrData, setQrData] = useState<{ sessionId: string; qrCode: string } | null>(null)
  const [reconnecting, setReconnecting] = useState(false)
  const [reconnectMsg, setReconnectMsg] = useState<{ type: 'success' | 'error' | 'info'; text: string } | null>(null)

  // Message tester
  const [testSessionId, setTestSessionId] = useState('')
  const [testChatId, setTestChatId] = useState('')
  const [testMsgType, setTestMsgType] = useState('text')
  const [testText, setTestText] = useState('')
  const [sending, setSending] = useState(false)
  const [sendResult, setSendResult] = useState<{ ok: boolean; text: string } | null>(null)

  // Show/hide API key
  const [showApiKey, setShowApiKey] = useState(false)

  // Auto-refresh
  const pollRef = useRef<NodeJS.Timeout | null>(null)

  const token = localStorage.getItem('auth_token')
  const hdrs = useCallback(() => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }), [token])

  /* ── Fetch overall status ──────────────────────────────────────────── */
  const fetchStatus = useCallback(async () => {
    try {
      const r = await fetch('/api/integrations/whatsapp/status', { headers: hdrs() })
      const d = await r.json()
      setConfigured(d.configured)
      setConnected(d.connected)
      if (d.baseUrl) setBaseUrl(d.baseUrl)
      if (d.apiKey) setApiKey(d.apiKey)
      if (d.activeSession) setActiveSession(d.activeSession)
      else setActiveSession(null)
    } catch {}
  }, [hdrs])

  /* ── Auto-check status on open + poll every 10s ────────────────── */
  useEffect(() => {
    if (!open) {
      if (pollRef.current) clearInterval(pollRef.current)
      return
    }
    fetchStatus()
    pollRef.current = setInterval(fetchStatus, 10000)
    return () => { if (pollRef.current) clearInterval(pollRef.current) }
  }, [open, fetchStatus])

  /* ── Whenever the gateway is reachable but the session isn't READY, keep a
   *    scannable QR loaded so it can be scanned straight from this panel. ── */
  useEffect(() => {
    const st = (activeSession?.status || '').toUpperCase()
    const sid = activeSession?.id || 'default'
    if (!open || !connected || st === 'READY') return
    let stopped = false
    const poll = async () => {
      try {
        const r = await fetch(`/api/integrations/whatsapp/sessions/${sid}/qr`, { headers: hdrs() })
        const d = await r.json()
        if (!stopped && d.qrCode) setQrData({ sessionId: sid, qrCode: d.qrCode })
        if (!stopped && d.status === 'ready') { setQrData(null); fetchStatus() }
      } catch {}
    }
    poll()
    const qid = setInterval(poll, 3000)
    return () => { stopped = true; clearInterval(qid) }
  }, [open, connected, activeSession, hdrs, fetchStatus])

  /* ── Connection actions ─────────────────────────────────────────────── */
  const handleTest = async () => {
    setTesting(true); setStatusMsg(null)
    try {
      const r = await fetch('/api/integrations/whatsapp/test', { method: 'POST', headers: hdrs(), body: JSON.stringify({ baseUrl, apiKey }) })
      const d = await r.json()
      setStatusMsg({ type: d.success ? 'success' : 'error', text: d.message || d.error || 'Unknown' })
    } catch { setStatusMsg({ type: 'error', text: 'Failed to reach WeQuote API' }) }
    setTesting(false)
  }

  const handleConnect = async () => {
    setConnecting(true); setStatusMsg(null)
    try {
      const r = await fetch('/api/integrations/whatsapp/connect', { method: 'POST', headers: hdrs(), body: JSON.stringify({ baseUrl, apiKey }) })
      const d = await r.json()
      if (d.success) { setConnected(true); setStatusMsg({ type: 'success', text: 'Connected to OpenWA!' }); fetchStatus() }
      else setStatusMsg({ type: 'error', text: d.error || 'Connection failed' })
    } catch { setStatusMsg({ type: 'error', text: 'Failed to reach WeQuote API' }) }
    setConnecting(false)
  }

  const handleDisconnect = async () => {
    await fetch('/api/integrations/whatsapp/disconnect', { method: 'POST', headers: hdrs() }).catch(() => {})
    setConnected(false); setConfigured(false); setSessions([]); setActiveSession(null)
    setStatusMsg({ type: 'info', text: 'Disconnected' })
  }

  /* ── Session actions ────────────────────────────────────────────────── */
  const loadSessions = useCallback(async () => {
    setLoadingSessions(true)
    try {
      const r = await fetch('/api/integrations/whatsapp/sessions', { headers: hdrs() })
      const d = await r.json()
      setSessions(Array.isArray(d) ? d : [])
    } catch { setSessions([]) }
    setLoadingSessions(false)
  }, [hdrs])

  useEffect(() => { if (tab === 'sessions' && (connected || configured)) loadSessions() }, [tab, connected, configured, loadSessions])

  const handleCreateSession = async () => {
    if (!newSessName.trim()) return
    setCreatingSess(true)
    setStatusMsg(null)
    try {
      const r = await fetch('/api/integrations/whatsapp/sessions', { method: 'POST', headers: hdrs(), body: JSON.stringify({ name: newSessName.trim() }) })
      const d = await r.json().catch(() => ({}))
      // Accept any 2xx response with either a flat {id,name} OR a wrapped
      // {data:{id,name}}. The api endpoint was returning the wrapped shape
      // straight from whatsappService, which made every successful create
      // look like a failure. We unwrap defensively so the modal works
      // against both the old wrapped shape and the new flat shape.
      const flat: any = d && d.data && (d.data.id || d.data.name) ? d.data : d
      if (r.ok && (flat.id || flat.name)) {
        setNewSessName('')
        setStatusMsg({ type: 'success', text: `Session "${flat.name || newSessName}" created.` })
        loadSessions()
      } else {
        const apiErr = (d && d.error && (d.error.message || d.error)) || (flat && flat.error)
        setStatusMsg({ type: 'error', text: apiErr || `Could not create session (HTTP ${r.status}). Check the gateway is reachable.` })
      }
    } catch (err: any) {
      setStatusMsg({ type: 'error', text: `Network error creating session: ${err?.message || 'unknown'}` })
    }
    setCreatingSess(false)
  }

  const handleStartSession = async (id: string) => {
    try {
      const r = await fetch(`/api/integrations/whatsapp/sessions/${id}/start`, { method: 'POST', headers: hdrs() })
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        setStatusMsg({ type: 'error', text: d.error || `Could not start session (HTTP ${r.status}).` })
        return
      }
    } catch (err: any) {
      setStatusMsg({ type: 'error', text: `Network error starting session: ${err?.message || 'unknown'}` })
      return
    }
    // Poll for QR code after starting
    setTimeout(async () => {
      await loadSessions()
      await handleGetQR(id)
    }, 3000)
  }

  const handleStopSession = async (id: string) => {
    try {
      const r = await fetch(`/api/integrations/whatsapp/sessions/${id}/stop`, { method: 'POST', headers: hdrs() })
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        setStatusMsg({ type: 'error', text: d.error || `Could not stop session (HTTP ${r.status}).` })
      }
    } catch (err: any) {
      setStatusMsg({ type: 'error', text: `Network error stopping session: ${err?.message || 'unknown'}` })
    }
    loadSessions()
  }

  const handleGetQR = async (id: string) => {
    try {
      // If session is disconnected/created/failed, start it first to trigger QR generation
      const statusRes = await fetch(`/api/integrations/whatsapp/sessions/${id}`, { headers: hdrs() })
      const statusData = await statusRes.json()
      const st = (statusData.status || '').toUpperCase()
      if (['DISCONNECTED', 'CREATED', 'FAILED'].includes(st)) {
        setReconnectMsg({ type: 'info', text: 'Starting session to generate QR code...' })
        await fetch(`/api/integrations/whatsapp/sessions/${id}/start`, { method: 'POST', headers: hdrs() }).catch(() => {})
        // Wait for QR to be generated
        for (let i = 0; i < 10; i++) {
          await new Promise(r => setTimeout(r, 2000))
          const qrRes = await fetch(`/api/integrations/whatsapp/sessions/${id}/qr`, { headers: hdrs() })
          const qrJson = await qrRes.json()
          if (qrJson.qrCode) {
            setQrData({ sessionId: id, qrCode: qrJson.qrCode })
            setReconnectMsg({ type: 'info', text: 'Scan the QR code below with WhatsApp on your phone' })
            loadSessions()
            return
          }
        }
        setReconnectMsg({ type: 'error', text: 'QR code generation timed out. Try clicking Reconnect instead.' })
        return
      }
      // If session is already READY (connected), no QR code is needed
      if (st === 'READY') {
        setQrData(null)
        setReconnectMsg({ type: 'info', text: 'WhatsApp is already connected — no QR code needed.' })
        return
      }
      // Session is in a state where QR should be available (QR_READY, INITIALIZING, etc.)
      const r = await fetch(`/api/integrations/whatsapp/sessions/${id}/qr`, { headers: hdrs() })
      const d = await r.json()
      if (d.qrCode) {
        setQrData({ sessionId: id, qrCode: d.qrCode })
      } else {
        setReconnectMsg({ type: 'error', text: 'No QR code available. Try clicking Reconnect first.' })
      }
    } catch {
      setReconnectMsg({ type: 'error', text: 'Failed to get QR code. Check that OpenWA is running.' })
    }
  }

  const handleDeleteSession = async (id: string) => {
    try {
      const r = await fetch(`/api/integrations/whatsapp/sessions/${id}`, { method: 'DELETE', headers: hdrs() })
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        setStatusMsg({ type: 'error', text: d.error || `Could not delete session (HTTP ${r.status}).` })
      }
    } catch (err: any) {
      setStatusMsg({ type: 'error', text: `Network error deleting session: ${err?.message || 'unknown'}` })
    }
    loadSessions()
    if (qrData?.sessionId === id) setQrData(null)
  }

  /* ── Reconnect (the key feature!) ──────────────────────────────────── */
  const handleReconnect = async (sessionId: string) => {
    setReconnecting(true)
    setReconnectMsg({ type: 'info', text: 'Reconnecting... This may take up to 30 seconds.' })
    setQrData(null)
    try {
      const r = await fetch(`/api/integrations/whatsapp/sessions/${sessionId}/reconnect`, { method: 'POST', headers: hdrs() })
      const d = await r.json()
      if (d.success && d.status === 'ready') {
        setReconnectMsg({ type: 'success', text: `Reconnected! Phone: +${d.phone || 'unknown'}` })
        fetchStatus()
      } else if (d.success && d.status === 'qr_ready' && d.qrCode) {
        setReconnectMsg({ type: 'info', text: 'Scan the QR code below with WhatsApp on your phone' })
        setQrData({ sessionId, qrCode: d.qrCode })
        // Start polling for ready status
        const pollForReady = setInterval(async () => {
          try {
            const sr = await fetch(`/api/integrations/whatsapp/sessions/${sessionId}`, { headers: hdrs() })
            const sd = await sr.json()
            if (sd.status === 'ready') {
              clearInterval(pollForReady)
              setQrData(null)
              setReconnectMsg({ type: 'success', text: `Connected! Phone: +${sd.phone || 'unknown'} (${sd.pushName || ''})` })
              fetchStatus()
            }
          } catch {}
        }, 3000)
        // Stop polling after 2 minutes
        setTimeout(() => clearInterval(pollForReady), 120000)
      } else {
        setReconnectMsg({ type: 'error', text: d.message || 'Reconnection failed' })
      }
    } catch (err: any) {
      setReconnectMsg({ type: 'error', text: 'Network error — check API server' })
    }
    setReconnecting(false)
  }

  /* ── Re-link: unlink the current number and show a fresh QR to scan ──── */
  const handleRelink = async (sessionId: string) => {
    if (!window.confirm('Unlink the current WhatsApp number and generate a new QR to scan?\n\nIncoming/outgoing WhatsApp will pause until you scan the new code with a phone.')) return
    setReconnecting(true)
    setReconnectMsg({ type: 'info', text: 'Unlinking current device — a QR will appear shortly…' })
    setQrData(null)
    try { await fetch(`/api/integrations/whatsapp/sessions/${sessionId}/logout`, { method: 'POST', headers: hdrs() }) } catch {}
    setReconnecting(false)
    await handleReconnect(sessionId)
  }

  /* ── Message tester ─────────────────────────────────────────────────── */
  const handleSendTest = async () => {
    if (!testSessionId || !testChatId) { setSendResult({ ok: false, text: 'Session ID and Chat ID required' }); return }
    setSending(true); setSendResult(null)
    try {
      const body: any = { sessionId: testSessionId, chatId: testChatId, type: testMsgType, text: testText }
      const r = await fetch('/api/integrations/whatsapp/send', { method: 'POST', headers: hdrs(), body: JSON.stringify(body) })
      const d = await r.json()
      if (d.messageId || d.success) setSendResult({ ok: true, text: `Sent! ID: ${d.messageId || 'ok'}` })
      else setSendResult({ ok: false, text: d.error || 'Send failed' })
    } catch { setSendResult({ ok: false, text: 'Network error' }) }
    setSending(false)
  }

  /* ── Render ─────────────────────────────────────────────────────────── */
  if (!open) return null

  const sessionStatus = (activeSession?.status || '').toUpperCase()
  const isReady = sessionStatus === 'READY'
  const needsReconnect = ['DISCONNECTED', 'FAILED'].includes(sessionStatus)

  const TABS: { id: Tab; label: string }[] = [
    { id: 'overview', label: 'Overview' },
    { id: 'sessions', label: 'Sessions' },
    { id: 'connection', label: 'Settings' },
    { id: 'tester', label: 'Test' },
  ]

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-surface rounded-2xl shadow-float border border-border w-full max-w-2xl max-h-[85vh] overflow-hidden">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <div className="flex items-center gap-3">
            <span className="text-2xl">📱</span>
            <div>
              <h2 className="text-lg font-bold text-txt-primary">OpenWA Gateway</h2>
              <p className="text-xs text-txt-tertiary">WhatsApp API gateway</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {connected && isReady && (
              <span className="flex items-center gap-1.5 text-xs font-medium text-success bg-success/10 px-2.5 py-1 rounded-full">
                <span className="w-1.5 h-1.5 bg-success rounded-full animate-pulse" /> Connected
              </span>
            )}
            {connected && needsReconnect && (
              <span className="flex items-center gap-1.5 text-xs font-medium text-error bg-error/10 px-2.5 py-1 rounded-full">
                <span className="w-1.5 h-1.5 bg-error rounded-full" /> Disconnected
              </span>
            )}
            {!connected && configured && (
              <span className="flex items-center gap-1.5 text-xs font-medium text-warning bg-warning/10 px-2.5 py-1 rounded-full">
                <span className="w-1.5 h-1.5 bg-warning rounded-full" /> Server Down
              </span>
            )}
            <button onClick={onClose} className="p-1 rounded-lg text-txt-tertiary hover:text-txt-primary hover:bg-surface-tertiary transition-colors"><XIcon /></button>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-border px-6">
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${tab === t.id ? 'text-brand-600 border-brand-600' : 'text-txt-tertiary border-transparent hover:text-txt-secondary'}`}>
              {t.label}
            </button>
          ))}
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto max-h-[calc(85vh-140px)]">

          {/* ═══ Overview Tab ═══════════════════════════════════════════════ */}
          {tab === 'overview' && (
            <div className="space-y-6">
              {/* Status Card */}
              {configured && connected ? (
                <div className={`p-5 rounded-xl border ${isReady ? 'border-success/30 bg-success/5' : needsReconnect ? 'border-error/30 bg-error/5' : 'border-warning/30 bg-warning/5'}`}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${isReady ? 'bg-success/20 text-success' : needsReconnect ? 'bg-error/20 text-error' : 'bg-warning/20 text-warning'}`}>
                        <PhoneIcon />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-txt-primary">
                          {isReady ? 'WhatsApp Connected' : needsReconnect ? 'WhatsApp Disconnected' : 'WhatsApp ' + sessionStatus}
                        </p>
                        <p className="text-xs text-txt-secondary mt-0.5">
                          {activeSession?.phone ? `+${activeSession.phone}` : 'No phone linked'}
                          {activeSession?.pushName ? ` (${activeSession.pushName})` : ''}
                        </p>
                      </div>
                    </div>
                    <span className={`text-[10px] font-semibold px-2.5 py-1 rounded-full ${STATUS_COLORS[sessionStatus] || 'bg-surface-tertiary text-txt-tertiary'}`}>{sessionStatus}</span>
                  </div>
                  {activeSession && (
                    <p className="text-[11px] text-txt-tertiary mt-3">
                      Session: {activeSession.name || activeSession.id.substring(0, 8)}
                      {activeSession.connectedAt && ` · Connected since ${new Date(activeSession.connectedAt).toLocaleString()}`}
                      {activeSession.lastActive && ` · Last active ${new Date(activeSession.lastActive).toLocaleString()}`}
                    </p>
                  )}
                </div>
              ) : configured && !connected ? (
                <div className="p-5 rounded-xl border border-warning/30 bg-warning/5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-warning/20 text-warning"><WarnIcon /></div>
                    <div>
                      <p className="text-sm font-semibold text-txt-primary">OpenWA Server Unreachable</p>
                      <p className="text-xs text-txt-secondary mt-0.5">Cannot connect to {baseUrl}</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="p-5 rounded-xl border border-border bg-surface-secondary">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-surface-tertiary text-txt-tertiary"><PhoneIcon /></div>
                    <div>
                      <p className="text-sm font-semibold text-txt-primary">WhatsApp Not Configured</p>
                      <p className="text-xs text-txt-secondary mt-0.5">Go to Settings tab to connect your OpenWA server</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Connect / QR-scan section — shown whenever the gateway is reachable but the session is not READY */}
              {connected && !isReady && (
                <div className="p-5 rounded-xl border border-border bg-surface-secondary">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-brand-600/10 text-brand-600"><QRIcon /></div>
                    <div>
                      <p className="text-sm font-semibold text-txt-primary">Link WhatsApp — scan the QR code</p>
                      <p className="text-xs text-txt-secondary">Open WhatsApp on your phone → Linked Devices → Link a Device, then scan the code below. It refreshes automatically.</p>
                    </div>
                  </div>

                  {reconnectMsg && (
                    <div className={`flex items-center gap-2 px-4 py-3 rounded-lg text-sm mb-4 ${reconnectMsg.type === 'success' ? 'bg-success/10 text-success' : reconnectMsg.type === 'error' ? 'bg-error/10 text-error' : 'bg-info/10 text-info'}`}>
                      {reconnectMsg.type === 'success' ? <CheckIcon /> : reconnectMsg.type === 'error' ? <WarnIcon /> : <Spinner />}
                      {reconnectMsg.text}
                    </div>
                  )}

                  {qrData && (
                    <div className="mb-4 p-6 rounded-xl border border-border bg-white dark:bg-surface text-center">
                      <p className="text-sm font-medium text-txt-primary mb-3">Open WhatsApp on your phone and scan this code</p>
                      <div className="inline-block p-3 bg-white rounded-lg border border-border">
                        {qrData.qrCode.startsWith('data:') ? (
                          <img src={qrData.qrCode} alt="QR" className="w-64 h-64" />
                        ) : (
                          <div className="w-64 h-64 flex items-center justify-center bg-surface-tertiary rounded text-xs text-txt-tertiary font-mono break-all p-2 overflow-auto">{qrData.qrCode}</div>
                        )}
                      </div>
                      <p className="text-[11px] text-txt-tertiary mt-3">WhatsApp &gt; Settings &gt; Linked Devices &gt; Link a Device</p>
                      <div className="flex justify-center gap-3 mt-3">
                        <button onClick={() => handleGetQR(qrData.sessionId)} className="text-xs text-brand-600 hover:underline flex items-center gap-1"><RefreshIcon /> Refresh QR</button>
                        <button onClick={() => setQrData(null)} className="text-xs text-txt-tertiary hover:underline">Close</button>
                      </div>
                    </div>
                  )}

                  <button
                    onClick={() => handleReconnect(activeSession?.id || 'default')}
                    disabled={reconnecting}
                    className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-brand-600 text-white text-sm font-medium hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors w-full justify-center"
                  >
                    {reconnecting ? <Spinner /> : <RefreshIcon />}
                    {reconnecting ? 'Generating QR…' : (qrData ? 'Refresh QR' : 'Generate QR code')}
                  </button>
                </div>
              )}

              {/* Quick Actions when connected */}
              {connected && isReady && (
                <div className="grid grid-cols-2 gap-3">
                  <button onClick={() => { setTab('tester'); if (activeSession) setTestSessionId(activeSession.id) }}
                    className="p-4 rounded-xl border border-border bg-surface-secondary hover:bg-surface-tertiary transition-colors text-left">
                    <div className="flex items-center gap-2 mb-2">
                      <SendIcon /> <span className="text-sm font-medium text-txt-primary">Send Test Message</span>
                    </div>
                    <p className="text-xs text-txt-tertiary">Verify the connection works</p>
                  </button>
                  <button onClick={() => handleRelink(activeSession?.id || 'default')}
                    className="p-4 rounded-xl border border-border bg-surface-secondary hover:bg-surface-tertiary transition-colors text-left">
                    <div className="flex items-center gap-2 mb-2">
                      <QRIcon /> <span className="text-sm font-medium text-txt-primary">Scan QR / Re-link</span>
                    </div>
                    <p className="text-xs text-txt-tertiary">Unlink &amp; pair a different number</p>
                  </button>
                </div>
              )}

              {/* QR appears here after Re-link, even while currently connected */}
              {connected && isReady && (qrData || reconnectMsg) && (
                <div className="p-5 rounded-xl border border-border bg-surface-secondary">
                  {reconnectMsg && (
                    <div className={`flex items-center gap-2 px-4 py-3 rounded-lg text-sm mb-4 ${reconnectMsg.type === 'success' ? 'bg-success/10 text-success' : reconnectMsg.type === 'error' ? 'bg-error/10 text-error' : 'bg-info/10 text-info'}`}>
                      {reconnectMsg.type === 'success' ? <CheckIcon /> : reconnectMsg.type === 'error' ? <WarnIcon /> : <Spinner />}
                      {reconnectMsg.text}
                    </div>
                  )}
                  {qrData && (
                    <div className="p-6 rounded-xl border border-border bg-white dark:bg-surface text-center">
                      <p className="text-sm font-medium text-txt-primary mb-3">Open WhatsApp on your phone and scan this code</p>
                      <div className="inline-block p-3 bg-white rounded-lg border border-border">
                        {qrData.qrCode.startsWith('data:')
                          ? <img src={qrData.qrCode} alt="QR" className="w-64 h-64" />
                          : <div className="w-64 h-64 flex items-center justify-center bg-surface-tertiary rounded text-xs text-txt-tertiary font-mono break-all p-2 overflow-auto">{qrData.qrCode}</div>}
                      </div>
                      <p className="text-[11px] text-txt-tertiary mt-3">WhatsApp &gt; Settings &gt; Linked Devices &gt; Link a Device</p>
                      <button onClick={() => setQrData(null)} className="text-xs text-txt-tertiary hover:underline mt-2">Close</button>
                    </div>
                  )}
                </div>
              )}

              {/* Capabilities Info */}
              <div className="p-4 rounded-xl bg-surface-secondary border border-border-light">
                <h4 className="text-sm font-semibold text-txt-primary mb-3">Capabilities</h4>
                <div className="grid grid-cols-2 gap-2">
                  {['Receive & respond to WhatsApp messages',
                    'Send images, videos, PDFs & documents',
                    'Real-time message delivery to agents',
                    'Multiple WhatsApp sessions (phone numbers)',
                    'Auto-resolve phone numbers from LID',
                    'QR code reconnection from dashboard',
                  ].map((f, i) => (
                    <div key={i} className="flex items-start gap-2 text-xs text-txt-secondary">
                      <CheckIcon className="w-3.5 h-3.5 text-success mt-0.5 flex-shrink-0" /> {f}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ═══ Sessions Tab ═════════════════════════════════════════════ */}
          {tab === 'sessions' && (
            <div className="space-y-5">
              {!connected && !configured ? (
                <div className="text-center py-12 text-txt-tertiary text-sm">Connect to an OpenWA server first (Settings tab).</div>
              ) : (<>
                <div className="flex items-end gap-3">
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-txt-primary mb-1.5">New Session</label>
                    <input type="text" value={newSessName} onChange={e => setNewSessName(e.target.value)} placeholder="e.g. support-line-1 (a-z, 0-9, hyphens)"
                      className="w-full px-3.5 py-2.5 rounded-lg border border-border bg-surface text-txt-primary text-sm focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500" onKeyDown={e => e.key === 'Enter' && handleCreateSession()} />
                  </div>
                  <button onClick={handleCreateSession} disabled={creatingSess || !newSessName.trim()} className="flex items-center gap-1.5 px-4 py-2.5 rounded-lg bg-brand-600 text-white text-sm font-medium hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                    {creatingSess ? <Spinner /> : <PlusIcon />} Create
                  </button>
                </div>
                <p className="text-xs text-txt-tertiary">Each session represents a linked WhatsApp phone number. Create a session, start it, then scan the QR code.</p>

                {loadingSessions ? (
                  <div className="flex items-center justify-center py-8 text-txt-tertiary"><Spinner /> <span className="ml-2 text-sm">Loading...</span></div>
                ) : sessions.length === 0 ? (
                  <div className="text-center py-10 text-txt-tertiary text-sm">No sessions yet.</div>
                ) : (
                  <div className="space-y-3">
                    {sessions.map(s => {
                      const st = (s.status || '').toUpperCase()
                      const sReady = st === 'READY'
                      const canStart = ['CREATED', 'DISCONNECTED', 'FAILED'].includes(st)
                      const canStop = ['READY', 'QR_READY', 'AUTHENTICATING', 'INITIALIZING'].includes(st)
                      const canQR = ['QR_READY', 'CREATED', 'DISCONNECTED', 'FAILED'].includes(st)
                      return (
                        <div key={s.id} className="p-4 rounded-xl border border-border bg-surface-secondary">
                          <div className="flex items-center justify-between">
                            <div>
                              <div className="flex items-center gap-2">
                                <p className="text-sm font-medium text-txt-primary">{s.name}</p>
                                <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${STATUS_COLORS[st] || 'bg-surface-tertiary text-txt-tertiary'}`}>{st}</span>
                              </div>
                              <p className="text-[11px] text-txt-tertiary mt-0.5">
                                ID: {s.id.substring(0, 8)}...
                                {s.phone && <> &middot; +{s.phone}</>}
                                {s.pushName && <> &middot; {s.pushName}</>}
                              </p>
                              {STATUS_DESCRIPTIONS[st] && (
                                <p className="text-[10px] text-txt-tertiary mt-0.5">{STATUS_DESCRIPTIONS[st]}</p>
                              )}
                            </div>
                            <div className="flex items-center gap-1.5">
                              {canStart && (
                                <button onClick={() => handleStartSession(s.id)} title="Start session" className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-success/10 text-success text-xs font-medium hover:bg-success/20 transition-colors"><PlayIcon /> Start</button>
                              )}
                              {canStop && (
                                <button onClick={() => handleStopSession(s.id)} title="Stop session" className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-warning/10 text-warning text-xs font-medium hover:bg-warning/20 transition-colors"><StopIcon /> Stop</button>
                              )}
                              {canQR && (
                                <button onClick={() => { handleReconnect(s.id) }} className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-brand-600/10 text-brand-600 text-xs font-medium hover:bg-brand-600/20 transition-colors"><RefreshIcon /> Reconnect</button>
                              )}
                              {canQR && (
                                <button onClick={() => handleGetQR(s.id)} className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg border border-border text-xs font-medium text-txt-secondary hover:bg-surface-tertiary transition-colors"><QRIcon /> QR</button>
                              )}
                              <button onClick={() => handleDeleteSession(s.id)} className="p-1.5 rounded-lg text-txt-tertiary hover:text-error hover:bg-error/10 transition-colors" title="Delete"><TrashIcon /></button>
                            </div>
                          </div>
                          {sReady && s.lastActive && (
                            <p className="text-[10px] text-txt-tertiary mt-1.5">Last active: {new Date(s.lastActive).toLocaleString()}</p>
                          )}
                        </div>
                      )
                    })}
                  </div>
                )}

                {/* QR Code Display */}
                {qrData && (
                  <div className="mt-4 p-6 rounded-xl border border-border bg-white dark:bg-surface text-center">
                    <p className="text-sm font-medium text-txt-primary mb-3">Scan with WhatsApp</p>
                    <div className="inline-block p-3 bg-white rounded-lg border border-border">
                      {qrData.qrCode.startsWith('data:') ? (
                        <img src={qrData.qrCode} alt="QR" className="w-64 h-64" />
                      ) : (
                        <div className="w-64 h-64 flex items-center justify-center bg-surface-tertiary rounded text-xs text-txt-tertiary font-mono break-all p-2 overflow-auto">{qrData.qrCode}</div>
                      )}
                    </div>
                    <p className="text-[11px] text-txt-tertiary mt-2">Session: {qrData.sessionId.substring(0, 8)}...</p>
                    <div className="flex justify-center gap-3 mt-2">
                      <button onClick={() => handleGetQR(qrData.sessionId)} className="text-xs text-brand-600 hover:underline flex items-center gap-1"><RefreshIcon /> Refresh</button>
                      <button onClick={() => setQrData(null)} className="text-xs text-txt-tertiary hover:underline">Close</button>
                    </div>
                  </div>
                )}

                {reconnectMsg && (
                  <div className={`flex items-center gap-2 px-4 py-3 rounded-lg text-sm ${reconnectMsg.type === 'success' ? 'bg-success/10 text-success' : reconnectMsg.type === 'error' ? 'bg-error/10 text-error' : 'bg-info/10 text-info'}`}>
                    {reconnectMsg.type === 'success' ? <CheckIcon /> : reconnectMsg.type === 'error' ? <WarnIcon /> : <Spinner />}
                    {reconnectMsg.text}
                  </div>
                )}

                <button onClick={loadSessions} disabled={loadingSessions} className="text-xs text-brand-600 hover:underline disabled:opacity-50">Refresh sessions</button>
              </>)}
            </div>
          )}

          {/* ═══ Connection Settings Tab ═════════════════════════════════ */}
          {tab === 'connection' && (
            <div className="space-y-5">
              <p className="text-sm text-txt-secondary">Connect your WeQuote platform to WhatsApp through the OpenWA Gateway.</p>

              <div>
                <label className="block text-sm font-medium text-txt-primary mb-1.5">OpenWA Server URL</label>
                <input type="url" value={baseUrl} onChange={e => setBaseUrl(e.target.value)} placeholder="http://localhost:2785/api" disabled={connected}
                  className="w-full px-3.5 py-2.5 rounded-lg border border-border bg-surface text-txt-primary text-sm focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500 disabled:opacity-60 disabled:cursor-not-allowed" />
              </div>

              <div>
                <label className="block text-sm font-medium text-txt-primary mb-1.5">API Key</label>
                <div className="flex items-center gap-2">
                  <input type={showApiKey ? 'text' : 'password'} value={apiKey} onChange={e => setApiKey(e.target.value)} placeholder="owa_k1_..." disabled={connected}
                    className="flex-1 min-w-0 px-3.5 py-2.5 rounded-lg border border-border bg-surface text-txt-primary text-sm font-mono focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500 disabled:opacity-60 disabled:cursor-not-allowed" />
                  {apiKey && (
                    <div className="flex items-center gap-1 shrink-0">
                      <button type="button" onClick={() => setShowApiKey(!showApiKey)} className="px-3 py-2.5 rounded-lg border border-border text-xs font-medium text-txt-secondary hover:text-txt-primary hover:bg-surface-tertiary transition-colors whitespace-nowrap">
                        {showApiKey ? 'Hide' : 'Show'}
                      </button>
                      <button type="button" onClick={() => { navigator.clipboard.writeText(apiKey); setStatusMsg({ type: 'success', text: 'API key copied to clipboard' }) }} className="px-3 py-2.5 rounded-lg border border-border text-xs font-medium text-txt-secondary hover:text-txt-primary hover:bg-surface-tertiary transition-colors whitespace-nowrap">
                        Copy
                      </button>
                    </div>
                  )}
                </div>
                <p className="text-[11px] text-txt-tertiary mt-1">
                  {configured && apiKey ? 'Auto-configured from server environment variables.' : 'Required for manual connection. Auto-configured servers use env variables.'}
                </p>
              </div>

              {configured && connected && apiKey && (
                <div className="p-3.5 rounded-lg bg-surface-secondary border border-border-light">
                  <p className="text-xs font-medium text-txt-primary mb-1.5">Connection Details</p>
                  <div className="space-y-1 text-[11px] text-txt-secondary">
                    <p><span className="text-txt-tertiary">Server:</span> {baseUrl}</p>
                    <p><span className="text-txt-tertiary">API Key:</span> {showApiKey ? apiKey : apiKey.substring(0, 4) + '••••••' + apiKey.substring(apiKey.length - 3)}</p>
                    <p><span className="text-txt-tertiary">Source:</span> Auto-configured from <span className="font-mono text-txt-primary">OPENWA_API_KEY</span> environment variable</p>
                  </div>
                </div>
              )}

              {configured && connected && (
                <div className="flex items-center gap-2 px-4 py-3 rounded-lg text-sm bg-success/10 text-success">
                  <CheckIcon /> Auto-configured and connected to {baseUrl}
                </div>
              )}

              {statusMsg && (
                <div className={`flex items-center gap-2 px-4 py-3 rounded-lg text-sm ${statusMsg.type === 'success' ? 'bg-success/10 text-success' : statusMsg.type === 'error' ? 'bg-error/10 text-error' : 'bg-info/10 text-info'}`}>
                  {statusMsg.type === 'success' ? <CheckIcon /> : <WarnIcon />} {statusMsg.text}
                </div>
              )}

              <div className="flex gap-3">
                {!connected ? (<>
                  <button onClick={handleTest} disabled={testing || !baseUrl || !apiKey} className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-border text-sm font-medium text-txt-secondary hover:bg-surface-tertiary disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                    {testing && <Spinner />} Test Connection
                  </button>
                  <button onClick={handleConnect} disabled={connecting || !baseUrl || !apiKey} className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-brand-600 text-white text-sm font-medium hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                    {connecting && <Spinner />} Connect
                  </button>
                </>) : (
                  <button onClick={handleDisconnect} className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-error/30 text-error text-sm font-medium hover:bg-error/10 transition-colors">Disconnect</button>
                )}
              </div>
            </div>
          )}

          {/* ═══ Message Tester Tab ═══════════════════════════════════════ */}
          {tab === 'tester' && (
            <div className="space-y-5">
              {!connected ? (
                <div className="text-center py-12 text-txt-tertiary text-sm">Connect to an OpenWA server first.</div>
              ) : (<>
                <p className="text-sm text-txt-secondary">Send a test message to verify the WhatsApp connection works.</p>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-txt-primary mb-1">Session ID</label>
                    <input type="text" value={testSessionId} onChange={e => setTestSessionId(e.target.value)} placeholder="Paste session UUID"
                      className="w-full px-3 py-2 rounded-lg border border-border bg-surface text-txt-primary text-sm focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500" />
                    {activeSession && !testSessionId && (
                      <button onClick={() => setTestSessionId(activeSession.id)} className="text-[10px] text-brand-600 hover:underline mt-1">Use active: {activeSession.id.substring(0, 8)}...</button>
                    )}
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-txt-primary mb-1">Chat ID</label>
                    <input type="text" value={testChatId} onChange={e => setTestChatId(e.target.value)} placeholder="447123456789@c.us"
                      className="w-full px-3 py-2 rounded-lg border border-border bg-surface text-txt-primary text-sm focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500" />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-medium text-txt-primary mb-1">Message</label>
                  <textarea value={testText} onChange={e => setTestText(e.target.value)} rows={3} placeholder="Hello from WeQuote!"
                    className="w-full px-3 py-2 rounded-lg border border-border bg-surface text-txt-primary text-sm focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500 resize-none" />
                </div>

                {sendResult && (
                  <div className={`flex items-center gap-2 px-4 py-3 rounded-lg text-sm ${sendResult.ok ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>
                    {sendResult.ok ? <CheckIcon /> : <WarnIcon />} {sendResult.text}
                  </div>
                )}

                <button onClick={handleSendTest} disabled={sending || !testSessionId || !testChatId} className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-brand-600 text-white text-sm font-medium hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                  {sending ? <Spinner /> : <SendIcon />} Send Test Message
                </button>

                <div className="p-4 rounded-xl bg-surface-secondary border border-border-light">
                  <h4 className="text-xs font-semibold text-txt-primary mb-2">Chat ID Format</h4>
                  <div className="space-y-1 text-[11px] text-txt-tertiary">
                    <p>Individual: <span className="font-mono text-txt-secondary">447123456789@c.us</span> (country code + number + @c.us)</p>
                    <p>Group: <span className="font-mono text-txt-secondary">120363012345678@g.us</span> (group ID + @g.us)</p>
                  </div>
                </div>
              </>)}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
